"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERepetitionType = void 0;
/**
 * Repetition type enumerator.
 *
 * @category Types & Interfaces.Repetitions
 * @internal
 */
var ERepetitionType;
(function (ERepetitionType) {
    /**
     * Defines the type of repetition of the shape,
     * in a circular way starting from the center of the scene
     * @order 1
     */
    ERepetitionType[ERepetitionType["Ring"] = 1] = "Ring";
    /**
     * Defines the type of repetition of the shape,
     * on a nxm grid starting from the center of the scene
     * @order 2
     */
    ERepetitionType[ERepetitionType["Matrix"] = 2] = "Matrix";
})(ERepetitionType = exports.ERepetitionType || (exports.ERepetitionType = {}));
//# sourceMappingURL=repetitions.js.map